import './index.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectCoverflow, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from 'react';
import { Dialog, IconButton, Modal } from '@mui/material';
import { isMobileQuery } from '../../../utils/helpers';
import { useMediaQuery } from 'react-responsive';

const ImageSlider = ({
  data
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSlide, setSelectedSlide] = useState(null);
	const isMobile = useMediaQuery(isMobileQuery)

  const openPreview = (slide) => {
    setSelectedSlide(slide);
    setIsModalOpen(true);
  };

  const closePreview = () => {
    setSelectedSlide(null);
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return <div className='h-full flex items-center'>
    <Swiper
      className='flex swiper-container items-center h-fit'
      effect="coverflow"
      grabCursor={true}
      centeredSlides={true}
      slidesPerView={1.3} // Number of visible slides (center + sides)
      loop={true}
      coverflowEffect={{
        rotate: 0, // Tilt angle of the slides
        stretch: 0, // Space between slides along z-axis
        depth: 100, // Depth of the 3D effect
        modifier: 5, // Multiplier for slide effects
        // slideShadows: true, // Adds shadow to the slides
      }}
      pagination={{ clickable: true }}
      navigation
      modules={[EffectCoverflow, Pagination, Navigation]}
    >
      {
        data.map((item, index) => {

          return <SwiperSlide key={index} onClick={() => openPreview(item)}>
            <img src={item.img} alt="slide_image"
              className='h-[36vw] md:h-full bg-cover'
            />
          </SwiperSlide>
        })
      }

    </Swiper>

    {isModalOpen && (
      <Dialog
        sx={{
          zIndex: '100000',
        }}
        PaperProps={{
          margin: isMobile ? '20px': 'initial'
        }}
        open={isModalOpen}
        onClose={closePreview}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'black',
            backgroundColor: 'white',
            border: '1px solid black',
            paddingInline: '10px',
            zIndex: 2,
          }}
        >
          <button
            className='leading-[1]'
            title="close"
          >
            ✕
          </button>
        </IconButton>

        <div className='p-1 lg:p-6 bg-slate-200 overflow-visible'>
          <div className='relative overflow-visible'>
            <img
              className='rounded-[10px] inset-0'
              src={selectedSlide.img}
              alt="Preview"
            />

          </div>
        </div>
      </Dialog>
    )}
  </div>
}

export default ImageSlider;